import React from 'react';
import { Card, CardBody, Row, Col } from 'reactstrap';
import { Line, Bar, Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const BookingsCharts = ({ data }) => {
  // Gráfico de reservas por día (últimos 15 días)
  const dailyBookingsData = {
    labels: data?.dailyBookings?.map(item => item.date) || [],
    datasets: [
      {
        label: 'Reservas',
        data: data?.dailyBookings?.map(item => item.count) || [],
        borderColor: '#2CA8FF',
        backgroundColor: 'rgba(44, 168, 255, 0.1)',
        tension: 0.4,
        fill: true
      }
    ]
  };

  // Gráfico de asistencia (asistió vs no asistió)
  const attendanceData = {
    labels: ['Asistió', 'No Asistió', 'Cancelado'],
    datasets: [
      {
        data: [
          data?.attendanceStats?.attended || 0,
          data?.attendanceStats?.no_show || 0,
          data?.attendanceStats?.cancelled || 0
        ],
        backgroundColor: ['#28a745', '#dc3545', '#ffc107'],
        borderWidth: 0
      }
    ]
  };

  // Gráfico de reservas por horario
  const timeSlotData = {
    labels: data?.timeSlotStats?.map(item => item.time_slot) || [],
    datasets: [
      {
        label: 'Reservas',
        data: data?.timeSlotStats?.map(item => item.count) || [],
        backgroundColor: 'rgba(127, 101, 82, 0.8)',
        borderColor: '#7F6552',
        borderWidth: 1
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false
      }
    },
    scales: {
      y: {
        beginAtZero: true
      }
    }
  };

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      }
    }
  };

  return (
    <Row className="mb-4">
      {/* Gráfico de reservas por día */}
      <Col lg="8" md="12" className="mb-4">
        <Card style={{ height: '400px' }}>
          <CardBody>
            <h5 className="card-title mb-3">Reservas por Día (Últimos 15 días)</h5>
            <div style={{ height: '300px' }}>
              <Line data={dailyBookingsData} options={chartOptions} />
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* Gráfico de asistencia */}
      <Col lg="4" md="6" className="mb-4">
        <Card style={{ height: '400px' }}>
          <CardBody>
            <h5 className="card-title mb-3">Estadísticas de Asistencia</h5>
            <div style={{ height: '300px' }}>
              <Doughnut data={attendanceData} options={doughnutOptions} />
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* Gráfico de horarios más populares */}
      <Col lg="12" className="mb-4">
        <Card style={{ height: '350px' }}>
          <CardBody>
            <h5 className="card-title mb-3">Horarios Más Populares</h5>
            <div style={{ height: '250px' }}>
              <Bar data={timeSlotData} options={chartOptions} />
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default BookingsCharts;
